var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-land pointer"},[_c('div',{staticClass:"is-land__container"},[_c('div',{on:{"click":_vm.onClickIsland}},[_c('div',{staticClass:"image",class:_vm.imageClass},[_c('div',{class:_vm.focusIconClass})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }